import * as I18n from 'circe/I18n';
import { NAME as APP_NAME } from 'constants';

export const WEIGHT_UNITS = {
  KG: I18n.str('kg', 'KG'),
  LB: I18n.str('lb', 'LB'),
};
export const NAME = `${APP_NAME}/FUSE`;

export const DIMS_UNITS = {
  CM: I18n.str('cm', 'CM'),
  IN: I18n.str('in', 'IN'),
};

export const LOCATION_TYPES = {
  Residence: 'Residence / Home Business',
  BusinessWithLoadingDockOrForklift: 'Business (with loading dock or forklift)',
  BusinessWithoutLoadingDockOrForklift: 'Business (without loading dock or forklift)',
  Port: 'Port',
  ConstructionSite: 'Construction Site',
  TradeShowOrConvention: 'Trade Show / Convention Center',
  StorageFacility: 'Storage Facility',
  MilitaryBase: 'Military Base',
  Airport: 'Airport',
  OtherSecuredLocation: 'Other Secured or Limited Access Location',
  FarmRanchEstate: 'Commercial Farm / Ranch / Marina',
  School: 'School / College',
  GovernmentLocation: 'Government Location',
  ReligiousInstitution: 'Religious Institution',
  GolfCourseResortPark: 'Restaurant / Hotel / Golf Course / Park',
  DistributionCenter: 'Distribution Center',
  Auction: 'Auction',
};
export const LOCAL_STORAGE = {
  pulseFilters: {
    cityFilter: 'PICKUP_CITY_PULSE',
    strategyTypeFilter: 'STRATEGY_TYPE_PULSE',
    vehicleTypeFilter: 'VEHICLE_TYPE_PULSE',
    vehicleLabelFilter: 'VEHICLE_LABEL_PULSE',
    courierFilter: 'COURIER_PULSE',
    fleetFilter: 'FLEET_PULSE',
  },
};
